var PaymentMethodCode;
(function (PaymentMethodCode) {
    PaymentMethodCode["BankTransfer"] = "banktransfer";
    PaymentMethodCode["BankTransferDirect"] = "worldline_redirect_payment_5408";
    PaymentMethodCode["CheckMoney"] = "checkmo";
    PaymentMethodCode["CreditCards"] = "worldline_hosted_checkout";
    PaymentMethodCode["PaypalExpress"] = "paypal_express";
    PaymentMethodCode["ApplePay"] = "worldline_redirect_payment_302";
    PaymentMethodCode["ApplePayExpress"] = "applepay_express";
    PaymentMethodCode["GooglePay"] = "worldline_redirect_payment_320";
    PaymentMethodCode["GooglePayExpress"] = "gpayexpress";
    PaymentMethodCode["Alma"] = "alma_monthly_payments";
    PaymentMethodCode["Alma_3"] = "alma|general:3:0:0";
    PaymentMethodCode["Alma_4"] = "alma|general:4:0:0";
})(PaymentMethodCode || (PaymentMethodCode = {}));
const PAYPAL_COUNTRIES_WITH_MANDATORY_REGION = [
    'AR',
    'BR',
    'CA',
    'CN',
    'IN',
    'ID',
    'IT',
    'JP',
    'MX',
    'TH',
    'US',
    'AE',
    'AA',
    'AP',
];

export { PaymentMethodCode as P, PAYPAL_COUNTRIES_WITH_MANDATORY_REGION as a };
//# sourceMappingURL=payment-YC9H491Y.js.map
